import _ from 'lodash'
import { resolvePlayerAssetUrl } from '@/lib/player-api'
import type { OriginalGame } from '@/types/original'

export function getSortedOriginalGames(games: OriginalGame[]): OriginalGame[] {
	return _.sortBy(games, 'order')
}

export function getOriginalGameImageUrl(game: OriginalGame): string {
	return resolvePlayerAssetUrl(game.image_url)
}

export function findOriginalGameById(games: OriginalGame[], gameId: string): OriginalGame | null {
	return _.find(games, { id: gameId }) ?? null
}
